import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-8 px-4 bg-[#050508] border-t border-gray-900 text-center" data-id="element-55">
      <div className="max-w-4xl mx-auto" data-id="element-56">
        <p className="text-gray-500 text-sm mb-2" data-id="element-57">
          © {currentYear} Facebook Ads Andrómeda. Todos los derechos
          reservados.
        </p>
        <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-58">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}